




import { Component, Vue } from 'vue-property-decorator'
import VisitDetail from './components/VisitDetail.vue'

@Component({
  name: 'EditVisit',
  components: {
    VisitDetail
  }
})
export default class extends Vue {}
